import React, { Component } from 'react'
import Link from '@components/Link'
import Lazyload from '@components/common/Lazyload/Lazyload'
import { setBackToPageTitle } from '@source/lib/globalUtil'
import { hubsBackground } from '@global/imageUrl'
import { placeholderBlank } from '@global/imageUrl'

import {
  link__mobile,
  link__desktop,
  border__desktop,
  border__mobile,
  label__desktop,
  label__mobile,
  logo__desktop,
  logo__mobile,
} from './style'

class HubItem extends Component {
  state = {
    hover: false,
  }
  toggleHover = () => {
    this.setState({ hover: !this.state.hover })
  }

  render() {
    const { data: { destPlaylistId, imageUrl, name, channelType, destPlaylistTitle }, isMobile } = this.props

    return (
      <>
        {isMobile ? (
          <Link to={setBackToPageTitle(`/${channelType}/${destPlaylistId}`, destPlaylistTitle)} className={link__mobile}>
            <div className={border__mobile}>
              {imageUrl ? (
                <Lazyload
                  src={imageUrl}
                  fallbackImageUri={`${placeholderBlank}?h=20`}
                  containerClassName={logo__mobile}
                />
              ) : (
                  <Lazyload containerClassName={logo__mobile}>
                    <div className={label__mobile}>
                      <p>{destPlaylistTitle}</p>
                    </div>
                  </Lazyload>
                )}
            </div>
          </Link>
        ) : (
            <Link to={`/${channelType}/${destPlaylistId}`} className={link__desktop}>
              <div
                className={border__desktop}
                style={this.state.hover ? { backgroundImage: `url(${hubsBackground})` } : null}
                onMouseEnter={this.toggleHover}
                onMouseLeave={this.toggleHover}
              >
                {imageUrl ? (
                  <Lazyload
                    src={imageUrl}
                    fallbackImageUri={`${placeholderBlank}?h=20`}
                    containerClassName={logo__desktop}
                  />
                ) : (
                    <Lazyload containerClassName={logo__desktop}>
                      <div className={label__desktop}>
                        <p>{destPlaylistTitle}</p>
                      </div>
                    </Lazyload>
                  )}
              </div>
            </Link>
          )}
      </>
    )
  }
}

export default HubItem
